import React from "react";

const Button = ({ onClick, children, type = "button", className = "", ...props }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={className
        ? className
        : "bg-white text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white font-bold py-1.5 px-4 rounded transition-colors"}
      style={{ cursor: "pointer" }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
